<template>
  <div class="justify-center">
    <div class="subheading font-weight-light">
      <br>
      <div class="text-xs-center px-4">
        
        <v-layout>
          <v-flex />
          <v-flex>
            <template>
              <vue-recaptcha ref="recaptcha" class="ma-10" sitekey="6LcI_mcUAAAAAAebiEZL4LhF1JcGDJqzI1kQ71b2"
                @verify="onVerify" @expired="onExpired" />
            </template>
          </v-flex>
        </v-layout>
        <v-flex />
        <br>
        <div v-show="respuestaCaptcha">
          <template>
            <v-layout row justify-center>
              <v-dialog v-model="dialog" persistent max-width="800">
                <template v-slot:activator="{ on }">
                  <v-btn color="success" outline round dark v-on="on">
                    <v-icon>send</v-icon>&nbsp;&nbsp;&nbsp;Enviar Solicitud
                  </v-btn>
                  <ChipFechaHora/>
                </template>
                <v-card>
                  <v-card-title>
                    <h2 class='primary--text'>CONFIRMAR ENVÍO DE SOLICITUD</h2>
                  </v-card-title>
                  <v-card-text>
                    <span>Su trámite está apunto de envíarse con la siguiente informacion:</span>
                    <br />
                    <div class="mt-2" style="border-radius:6px;border: 1px solid gray;overflow:hidden;">
                      <table border="1" class="table_documentos_adjuntados">
                        <tr v-for="(registro, index) in informacionDeclararEmpresa.informacion" :key="index">
                          <td>{{ informacionDeclararEmpresa.documentos[index] }}</td>
                          <td :style="{ fontWeight: informacionDeclararEmpresa.documentos[index] === 'Correo de la Empresa' ? 'bold' : 'normal' }">
                            {{ registro }}
                          </td>
                        </tr>
                        <tr v-for="(registro, index) in informacionDeclararRepresentante.informacion"
                          :key="index + informacionDeclararEmpresa.informacion.length">
                          <td>{{ informacionDeclararRepresentante.documentos[index] }}</td>
                          <td>{{ registro }}</td>
                        </tr>
                      
                      </table>
                    </div>
                    <br>
                    <span>¿Está seguro de enviar su solicitud de <strong>OTORGACIÓN DE CREDENCIALES?</strong>
                      ?</span>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="dialog = false">No</v-btn>
                    <v-btn color="green darken-1" flat @click="enviarSolicitud();">Si</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </template>
          
          <br><br><br>
        </div>
        
          
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import {mapMutations, mapActions, mapGetters } from "vuex";
import types from '@/store/types/SolicitudCredenciales'
import ChipFechaHora from "@/components/ChipFechaHora.vue";
import HorarioAtencion from "@/components/HorarioAtencion.vue";

export default {
  components: {
    VueRecaptcha,
    ChipFechaHora,
    HorarioAtencion,
  },
  data() {
    return {
      respuestaCaptcha: false,
      vLoading: false,
      dialog: false,
      informacionDeclararEmpresa: { documentos: [], informacion: [] },
      informacionDeclararRepresentante: { documentos: [], informacion: [] },
      informacionRecuperada: { documentos: [], informacion: [] },
      informacionMostrar: {},
    }
  },
  watch: {
    respuestaCaptcha() {
      this.llenarInformacion()
    },
  },
  methods: {
    async enviarSolicitud() {

      this.dialog = false
      this.EnvioDeSolicitud()
    },
    llenarInformacion() {
      if (this.GetDatosSin.resultado) {
        
        this.informacionDeclararEmpresa = {
          documentos: ["NIT",
            "Nombre o Razon Social",
            "Departamento de Domicilio Fiscal",
            "Dirección de la Empresa",
            "Teléfono de la Empersa",
            "Correo de la Empresa"],
          informacion: [this.GetDatosSin.resultado.nit,
          this.GetDatosSin.resultado.nombreRazonSocial,
          this.GetDatosSin.resultado.dependencia,
          this.GetDatosSin.resultado.direccion +" "+this.GetDatosSin.resultado.direccionDescriptiva,
          this.GetDatosSin.resultado.telefonoEmpresa,
          this.GetDatosSin.resultado.correoEmpresa,
          ]
        }
      }
      if (this.GetDatosRepresentante) {
        this.informacionDeclararRepresentante = {
          documentos: ["Representante Legal",
            "Cedula de Identidad del Representante",
            "Teléfono del Representante",
            "Correo del Representante"],
          informacion: [this.GetDatosRepresentante.Nombres + " " + this.GetDatosRepresentante.PrimerApellido + " " + this.GetDatosRepresentante.SegundoApellido,
          this.GetDatosRepresentante.ComplementoDocumento ? this.GetDatosRepresentante.NumeroDocumento + "-" + this.GetDatosRepresentante.ComplementoDocumento : this.GetDatosRepresentante.NumeroDocumento,
          this.GetDatosRepresentante.TelefonoRepresentante,
          this.GetDatosRepresentante.CorreoRepresentante,
          ],
        }
      }   

    },
    onVerify(response) {

      this.respuestaCaptcha = true
    },
    onExpired() {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.respuestaCaptcha = false;
    },
    
    ...mapActions({
      EnvioDeSolicitud: types.actions.EnvioDeSolicitud,     
    }),
    ...mapMutations({
      SetDatosSin: types.getters.SetDatosSin,
      SetValidacionSegip: types.getters.SetValidacionSegip,
      SetDatosRepresentante: types.getters.SetDatosRepresentante,
    })


  },
  computed: {
    ...mapGetters({
      GetDatosSin: types.getters.GetDatosSin,
      GetValidacionSegip: types.getters.GetValidacionSegip,
      GetDatosRepresentante: types.getters.GetDatosRepresentante,
      GetDatosGuardados: types.getters.GetDatosGuardados,
    })
  }
}

</script>

<style>
.g-recaptcha {
  width: 300px;
  margin: 0 auto auto auto;
}

.table_documentos_adjuntados {
  border-collapse: collapse;
  width: 100%;
  border-radius: 6px;
  border: 1px solid gray;
  overflow: hidden;
}

.table_documentos_adjuntados tr {
  border-bottom: 1px solid gray;
}

.table_documentos_adjuntados tr td {
  padding: 8px;
}
</style>



